module.exports = __webpack_public_path__ + "img/grocery-boy.6f49ede4.svg";